import {
    DEALERSENDINCASHIN_FAILED,
    DEALERSENDINCASHIN_SUCCESS,
    RESET_DEALERSENDINCASHIN,
    LOADING_DEALERSENDINCASHIN,
    NETWORK_ERROR_DEALERSENDINCASHIN
} from '../types/index'

import { dealerServices } from "../../config/axios";
const resetDealerSendInCashIn = () => {
    return { type: RESET_DEALERSENDINCASHIN };
};
const dealerSendInCashInList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERSENDINCASHIN });
    await dealerServices
        .post("sendCashin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerSendInCashInsuccess(res.data));
                    break;
                default:
                    dispatch(dealerSendInCashInFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERSENDINCASHIN,
                payload: err
            });
        });
};

function dealerSendInCashInsuccess(data) {
    return {
        type: DEALERSENDINCASHIN_SUCCESS,
        payload: data
    };
}
function dealerSendInCashInFailed(data) {
    return {
        type: DEALERSENDINCASHIN_FAILED,
        payload: data
    };
}

export { resetDealerSendInCashIn, dealerSendInCashInList }